export const SUBSCRIBE_OPERATION_TYPES = {
  SUBSCRIBE: 'subscribe',
  UNSUBSCRIBE: 'unsubscribe',
  UPDATE: 'update'
}
